<template>
  <div class="bg background">
    <div class="layer"></div>
  </div>
  <div class="container-fluid">
    <ul class="socials mt-3">
      <li v-for="(sm, i) in sms" :key="i">
        <a target="_blank" v-bind:href="sm.link"><i :class="sm.fontAwesome"></i></a>
      </li>
    </ul>
    <div class="bg canvas can-square mt-3 mb-3 " v-bind:style="{ backgroundImage: 'url(' +  require(`@/assets/img/wisenheim.jpg`) + ')' }"></div>
    <div class="row gutb-15px links">
      <div v-for="(link, index) in links" :key="index" class="col-12">
        <a target="_blank" v-bind:href="link.link" class="link">
          <div class="title">{{ link.title }}</div>
          <div class="description">{{ link.description }}</div>
        </a>
      </div>
    </div>
    <ul class="socials mt-6 mb-3">
      <li v-for="(sm, i) in sms" :key="i">
        <a target="_blank" v-bind:href="sm.link"><i :class="sm.fontAwesome"></i></a>
      </li>
    </ul>
  </div>
</template>

<script>
import {sms} from "@/data/socialmedia";
import {wisenheimerLinks} from "@/data/wisenheimerLinks";

export default {
  name: "WisenheimerView",
  data() {
    return {
      links: wisenheimerLinks,
      sms: sms
    };
  },
}
</script>

<style scoped>
.links {
  font-family: GroteskRemixtest;
}

.background .layer {
  opacity: 0.1;
  background-color: rgb(186,190,201);
}
ul.socials > li > a {
  color: white;
  text-stroke: black 1.5px;
  -webkit-text-stroke: black 1.5px;
}
a.link {
  border-color: rgb(186,190,201);
  background-color: var(--white-op05);
  color: black;
}
a.link:hover {
  background-color: black;
  color: white;
  text-stroke: rgb(186,190,201) 1px;
  -webkit-text-stroke: rgb(186,190,201) 1px;
}
ul.socials > li > a:hover {
  color: var(--red);
  color: black;
}
</style>